import React, { Component, Fragment } from 'react';
import {NavLink} from 'react-router-dom'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AADService from '../Azure/AADService';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import * as proyectAction from "../../store/actions/proyectAction";
import { rolAcceso } from '../../Config/const';

class AppSubmenu extends Component {

    static defaultProps = {
        className: null,
        items: null,
        onMenuItemClick: null,
        root: false
    }

    static propTypes = {
        className: PropTypes.string,
        items: PropTypes.array,
        onMenuItemClick: PropTypes.func,
        root: PropTypes.bool
    }
    
    constructor(props) {
        super(props);
        this.state = {activeIndex: null};
        this.AzureADService = new AADService();
    }
    logOut(e) {
        e.preventDefault()
        this.props.setUserDataFromLocalStorage(null);
        this.AzureADService.logout();        
    }
    onMenuItemClick(event, item, index) {
        //console.log(item)
        this.props.setPlantaActual(item)
        //avoid processing disabled items
        if(item.disabled) {
            event.preventDefault();
            return true;
        }
                        
        //execute command
        if(item.command) {
            item.command({originalEvent: event, item: item});
        }

        if(index === this.state.activeIndex)
            this.setState({activeIndex: null});    
        else
            this.setState({activeIndex: index});

        if(this.props.onMenuItemClick) {
            this.props.onMenuItemClick({
                originalEvent: event,
                item: item
            });
        }
    }

	renderLinkContent(item) {
		let submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
		let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;

		return (
			<React.Fragment>
				<i className={item.icon}></i>
				<span>{(item.label)} </span>
				{submenuIcon}
				{badge}
			</React.Fragment>
		);
	}

	renderLink(item, i) {
		let content = this.renderLinkContent(item);
		if (item.to) {
			return (
				<NavLink activeClassName="active-route " to={item.to} onClick={(e) => this.onMenuItemClick(e, item, i)} exact={true} target={item.target}>
                    {content}
                </NavLink>
			)
		}
		else {
			return (
				<a href={item.url} onClick={(e) => this.onMenuItemClick(e, item, i)} target={item.target}>
					{content}
				</a>
			);

		}
	}
    
    render() {        
        const { t } = this.props;
        let items = this.props.items && this.props.items.map((item, i) => {
            let active = this.state.activeIndex === i;
            let styleClass = classNames(item.badgeStyleClass, {'active-menuitem': active && !item.to});
            if(item.label==="Configuracion"){
                item.label=t("Configuracion")
            }
            return (
                <li className={styleClass} key={i}>
                    {item.items && this.props.root===true && <div className='arrow'></div>}
                    {this.renderLink(item, i)}
                    <AppSubmenu items={item.items} onMenuItemClick={this.props.onMenuItemClick}/>
                </li>
            );
        });
        let rol="";
        if(this.props.global){
            if(this.props.global.user){
                rol=this.props.global.user.roles
            }
        }
        
        const Logout=()=>{
            return(
                <Fragment>
                    <li>
                        <NavLink activeClassName="active-route" to={"/"} onClick={(e) => this.logOut(e)} exact={true} >
                            <i className="pi pi-fw pi-sign-out"/>
                            <span>{t("Logout")}</span>
                        </NavLink>
                    </li>
                </Fragment>
            );
        }        
        return items ? <ul className={this.props.className}>{items}{Logout()}</ul> : null;
    }
}

const mapStateToProps = (rootReducer) => {
    return {global: rootReducer.proyect};
};

export default connect(mapStateToProps, proyectAction)(withTranslation ("translations") (AppSubmenu));